import React from 'react';
import JoditEditor from 'jodit-react';
import { backend } from './apipath';

const HTMLEditor = (contents, name, callBack) => {
	//const editor = useRef(null);
	//const [content, setContent] = useState(contents ?? '');


	return (
		<JoditEditor
    value={contents}
    tabIndex={1}
    name={name}
    config={{
        uploader: {
            insertImageAsBase64URI: false,
            url: `${backend}news/upload`,
            method: "POST",
            
            isSuccess: (resp) => resp && resp.filePath,
            process: (resp) => resp.filePath, // 插入圖片網址
        },
        language: "zh_tw",
        height: 600,
    }}
    onChange={(newContent) => callBack(name, newContent)}
/>

	);
};

export default HTMLEditor; 